import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DocumentTypeLetterRulling } from './documenttypeletterrulling';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumenttypeletterrullingService {

  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }

  Get(): Observable<DocumentTypeLetterRulling[]> {
    return this.httpClient.get<DocumentTypeLetterRulling[]>(this.baseUrl + 'api/DocumentTypeLetterRullingApi')
  }
  GetActive(): Observable<DocumentTypeLetterRulling[]> {
    return this.httpClient.get<DocumentTypeLetterRulling[]>(this.baseUrl + 'api/DocumentTypeLetterRullingApi/GetActiveDocumentTypeLetterRulling')
  }
  Post(documenttypeletterrulling: DocumentTypeLetterRulling): Observable<any> {

    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/DocumentTypeLetterRullingApi/add', documenttypeletterrulling, { headers: header, observe: 'response' })
  }
  Delete(documenttypeletterrulling: DocumentTypeLetterRulling) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/DocumentTypeLetterRullingApi/activeordeactive', documenttypeletterrulling, { headers: header, observe: 'response' })
  }
  Put(documenttypeletterrulling: DocumentTypeLetterRulling): Observable<any> {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put(this.baseUrl + 'api/DocumentTypeLetterRullingApi/Update', documenttypeletterrulling, { headers: header, observe: 'response' })
  }

}
